import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Static, public rendering of the VIVE Client Service Agreement — the terms
 * that follow the Order Form signature page in the client contract template.
 * The text is legal copy: change it only to match a revised template, never
 * to fix wording or typos on our own.
 */
@Component({
  selector: 'app-client-service-agreement',
  templateUrl: './client-service-agreement.component.html',
  styleUrls: ['./client-service-agreement.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientServiceAgreementComponent {}
